export const SAVE_ALL_BOARDING_LINES = 'SAVE_ALL_BOARDING_LINES'